<template>

<div class="carousel">
    
    <owl-carousel :items='owlItems' :opts='owlOptions'></owl-carousel>
    
</div>

</template>

<script>
    export default {

        mounted() {

        },

        created() {
            
            if( typeof this.p != 'object' ) {
                var projects = JSON.parse( this.p );
            } else {
                var projects = this.p;
            }


            for( var i in projects ) {
            
                this.owlItems.push({
                    id : projects[i].id,
                    image : projects[i].image_thumb,
                    title : projects[i].name,
                    alt   : projects[i].name
                });
            
            }

        },  

        props : ['p'],

        data() {
            return {
                isReady : false,

                owlItems : [
                    // { id : 1, title : 'Предложение за дизайн на апартамент', image : '/resources/images/static/1.jpg', alt : 'Title' },
                    // { id : 2, title : 'Предложение за дизайн на апартамент', image : '/resources/images/static/2.jpg', alt : 'Title' },
                    // { id : 3, title : 'Предложение за дизайн на апартамент', image : '/resources/images/static/3.jpg', alt : 'Title' },
                    // { id : 4, title : 'Предложение за дизайн на апартамент', image : '/resources/images/static/4.jpg', alt : 'Title' },
                    // { id : 5, title : 'Предложение за дизайн на апартамент', image : '/resources/images/static/5.jpg', alt : 'Title' },
                    // { id : 6, title : 'Предложение за дизайн на апартамент', image : '/resources/images/static/6.jpg', alt : 'Title' },
                    // { id : 7, title : 'Предложение за дизайн на апартамент', image : '/resources/images/static/7.jpg', alt : 'Title' },
                    // { id : 8, title : 'Предложение за дизайн на апартамент', image : '/resources/images/static/8.jpg', alt : 'Title' }
                ],

                owlOptions : {
                    loop            : true,
                    center          : true,
                    nav             : true,
                    items           : 1,
                    margin          : 10,
                    stagePadding    : 30,
                    responsive:{
                        600 : {
                           items    : 3,
                        }
                    }
                },

            }
        },

        methods : {

        }

    }
</script>
